import { createClient } from '@supabase/supabase-js';

// Get the URL and anon key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// More detailed logging to diagnose issues
// ... existing code ...

// Ensure we have the required config
if (!supabaseUrl || !supabaseAnonKey) {
  // ... existing code ...
  
  // In development, provide a fallback to avoid breaking the app
  if (process.env.NODE_ENV === 'development') {
    // ... existing code ...
  }
}

// Create the Supabase client with fallback for development
const finalSupabaseUrl = supabaseUrl || 'https://ejhmgjbzayxljlcdaryv.supabase.co';
const finalSupabaseAnonKey = supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVqaG1namJ6YXl4bGpsY2Rhcnl2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA4MjI5MDIsImV4cCI6MjA1NjM5ODkwMn0.BraYWPA5GcWFXPPbW_7wPImfQXSwL6IJ3OZLta2Yllk';
export const isSupabaseConfigured = Boolean(finalSupabaseUrl && finalSupabaseAnonKey);
export const getSupabaseConfigError = () => (
  isSupabaseConfigured
    ? null
    : 'Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.'
);

// Add extra logging for the final values used
// ... existing code ...

export const supabase = createClient(finalSupabaseUrl, finalSupabaseAnonKey);

// Export a function to check the connection to Supabase
export const checkSupabaseConnection = async () => {
  return {
    success: isSupabaseConfigured,
    error: isSupabaseConfigured ? null : new Error(getSupabaseConfigError()),
  };
}; 
